module.exports = __webpack_public_path__ + "static/img/15.a507cfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/T恤/15.png
// module id = SngC
// module chunks = 0